import axios from "axios";

export const getAllSchedule = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/schedule/get-all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener comercios";
  }
};

export const createScheduleService = async (userData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token provided");
  try {
    const { data } = await axios.post(`${API_URL}/api/schedule`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear comercio");
  }
};

export const updateScheduleService = async (id, userData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(`${API_URL}/api/schedule/${id}`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al actualizar agendamiento";
  }
};

export const deleteScheduleService = async (userId) => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No hay token de autenticación");
  }

  try {
    const response = await axios.delete(`${API_URL}/api/schedule/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error al eliminar agendamiento";
    throw new Error(errorMessage);
  }
};
